import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { IContactUsCommunicate } from "@Types/contact-us-page";
import classes from "./ContactUs.module.scss";

interface Props extends IContactUsCommunicate {}

export const ContactUsCommunicate = (props: Props) => {
  return (
    <div className={classes["contact-us-page__communicate"]}>
      <h3>{props.contactTitle}</h3>
      <div className={classes["contact-us-page__hours"]}>
        <CmsTextEditorContent content={props.contactHours} />
      </div>
      <h4>{props.contactCustomerService}</h4>
      <span className={classes["tollfree"]}>
        {props.contactCustomerServiceNumber}
      </span>
    </div>
  );
};
